module.exports = __webpack_public_path__ + "static/media/mhv-icon.f7c183ca.svg";